<template>
    <bill-shell>
        <section id="more" class="section py-5 bg-white">
            <div class="container text-left">
                <h1 class="text-9 font-weight-bold mb-4 mt-2">
                    Ditch the Queues, Top Up Your TelOne Wi-Fi Online with Magetsi!
                </h1>
                <p class="text-3">
                    Gone are the days of waiting in long queues or venturing out just to top up your TelOne Wi-Fi.
                    Here at Magetsi, we understand the importance of staying connected, and that's why we've made it
                    easier than ever to manage your TelOne Wi-Fi account - all from the comfort of your couch!
                </p>
            </div>
        </section>
        <section class="section py-5 bg-light-4">
            <div class="container">
                <h2 class="text-7 font-weight-bold mb-4 text-left">
                    Introducing TelOne Wi-Fi Top-Up on Magetsi.co.zw!
                </h2>

                <div class="px-5 text-justify">
                    <p class="text-3 mb-4 mt-3">
                        Now, you can conveniently top up your TelOne Wi-Fi directly on our secure platform.
                        Whether you're running low on data or simply need to extend your subscription,
                        Magetsi ensures a quick and hassle-free experience.
                    </p>
                    <h3 class="text-5 font-weight-bold mb-4 text-left">
                        Here's How to Top Up Your TelOne Wi-Fi with Magetsi:
                    </h3>
                    <ol class="text-3">
                        <li class="py-1">
                            Visit Magetsi.co.zw: Head over to our website and navigate to the "TelOne Services" section.
                        </li>
                        <li  class="py-1">
                            Select "TelOne Wi-Fi Top Up": Clearly identify the service you want to top up.
                        </li>
                        <li  class="py-1">
                            Enter Your Account Details: Accurately input your TelOne Wi-Fi account number. This ensures the top-up reaches the correct account.
                        </li>
                        <li  class="py-1">
                            Choose Your Top-Up Amount: We offer various denominations to suit your needs, allowing you to select the data bundle or subscription plan you desire.
                        </li>
                        <li  class="py-1">
                            Pick Your Payment Method: Magetsi provides several secure payment options for your convenience. Choose from EcoCash, VISA, or Mastercard.
                        </li>
                        <li  class="py-1">
                            Complete the Transaction: Follow the on-screen instructions to finalize your payment. Once successful, you'll receive confirmation and your TelOne Wi-Fi account will be instantly topped up.
                        </li>
                    </ol>
                    <h3 class="text-5 font-weight-bold mb-4 text-left">
                        Benefits of Topping Up Your TelOne Wi-Fi with Magetsi:
                    </h3>
                    <ul class="text-3">
                        <li class="py-1">
                            Convenience: Top up your TelOne Wi-Fi anytime, anywhere, without leaving your home or office.
                        </li>
                        <li  class="py-1">
                            Speed: Instantaneous processing ensures your Wi-Fi is active the moment your payment is complete
                        </li>
                        <li  class="py-1">
                            Security: Our platform utilizes secure payment gateways to protect your financial information.
                        </li>
                        <li  class="py-1">
                            Variety: We offer a wide range of top-up options to suit your data usage needs.
                        </li>
                        <li  class="py-1">
                            Transparency: You'll see all the details of your chosen top-up amount before confirming the transaction.
                        </li>
                    </ul>
                    <h3 class="text-5 font-weight-bold mb-4 text-left">
                        Telone Wi-Fi in Your Home
                    </h3>
                    <p class="text-3 mb-4 mt-3">
                        A reliable Wi-Fi connection at home plays a pivotal role in today's interconnected world, offering
                        unmatched convenience, flexibility, and accessibility. It serves as the digital gateway that connects
                        us to a vast array of resources, from educational materials and work-related tools to entertainment
                        options and communication platforms. With Wi-Fi, we can seamlessly navigate through online tasks,
                        stay connected with friends and family through video calls, stream our favorite movies and music,
                        and even control smart home devices for added convenience. It's not just about internet access; it's
                        about unlocking endless possibilities and enhancing our daily lives by staying connected, informed,
                        and entertained right from the comfort of our homes.
                    </p>
                    <h3 class="text-5 font-weight-bold mb-4 text-left">
                        Telone Wi-Fi in Your Office
                    </h3>
                    <p class="text-3 mb-4 mt-3">
                        A robust Wi-Fi connection is of paramount importance in a modern office environment, where seamless
                        connectivity is essential for productivity, collaboration, and efficiency. It serves as the backbone
                        of communication, allowing teams to stay connected, share files, and collaborate on projects in real-time.
                        With Wi-Fi, employees can access cloud-based tools and resources, participate in virtual meetings, and
                        leverage online platforms for research and information gathering. This connectivity empowers teams to work
                        flexibly, whether in the office, at remote locations, or while on the go, without being tethered to physical
                        cables. Moreover, Wi-Fi enables the integration of smart office technologies, such as IoT devices and automated
                        systems, optimizing workflows and enhancing the overall operational effectiveness of the workplace. In essence,
                        a reliable Wi-Fi connection in the office is not just a convenience but a fundamental necessity for driving
                        productivity, fostering collaboration, and embracing digital transformation. Top up your Telone Wi-Fi now and
                        keep office productivity high.
                    </p>
                    <h3 class="text-5 font-weight-bold mb-4 text-left">
                        Stay Connected with Magetsi!
                    </h3>
                    <p class="text-3 mb-4 mt-3">
                        Magetsi is your one-stop shop for managing your essential services. In addition to TelOne Wi-Fi top-up,
                        we also offer convenient ways to purchase Zesa tokens, top-up mobile airtime, renew your car insurance &
                        Zinara, and settle other bills from the comfort of your home.
                    </p>
                    <p class="text-3 mb-4 mt-3">
                        So, why wait? Visit Magetsi.co.zw today and experience the ease of managing your TelOne Wi-Fi online!
                    </p>
                </div>
            </div>
        </section>
    </bill-shell>
</template>

<script>
import BillShell from "./bill-shell.vue";

export default {
    name: "dashboard",
    components: {BillShell},
    data: () => ({
        content: [
            {
                title: 'Recharge Your\nTelOne Account',
                subtitle: 'Need to recharge your TelOne Broadband, Phone or Blaze account? Enter your details to get started. Accepted payment methods on our platform include EcoCash, MasterCard, VISA, and other international cards.',
            },
            {
                title: 'Get Up To\n15% DISCOUNT!!!',
                subtitle: 'When you pay using MasterCard, Visa, or other international cards.',
            }
        ]
    }),
    mounted() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    },
}
</script>
